'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import MuiIconButton from '@mui/material/IconButton';
import { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
const StyledIconButton = styled(MuiIconButton)(() => ({}));
interface IconButtonProps extends MuiIconButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  noRipple?: boolean;
  ariaLabel?: string;
}
const IconButton: React.FC<IconButtonProps> = t0 => {
  const $ = _c(10);
  let ariaLabel;
  let children;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      onClick,
      ariaLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = children;
    $[3] = onClick;
    $[4] = props;
  } else {
    ariaLabel = $[1];
    children = $[2];
    onClick = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== ariaLabel || $[6] !== children || $[7] !== onClick || $[8] !== props) {
    t1 = <StyledIconButton onClick={onClick} aria-label={ariaLabel} {...props}>{children}</StyledIconButton>;
    $[5] = ariaLabel;
    $[6] = children;
    $[7] = onClick;
    $[8] = props;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export default IconButton;
export type { IconButtonProps };